/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Total_CostInputs */



/**
* | output |
* | --- |
* | "Total Cost" |
*
* @param {Dashboard_Total_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_total_cost = /** @type {((inputs?: Dashboard_Total_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Total_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten gesamt")
	return /** @type {LocalizedString} */ ("Total Cost")
});